module.exports = __webpack_public_path__ + "static/media/logo-full--light.5b0fbc88.svg";